import React, { useState, useEffect } from "react";
import Axios from "axios";
import './Search.css';
import MovieComponent from "../../Components/MovieComponent/MovieComponent";
import MovieInfoComponent from "../../Components/MovieComponent/MovieInfoComponent";
const API_KEY = '1d80089c';

const Search = () => {
  const [searchQuery, updateSearchQuery] = useState("");
  const [movieList, updateMovieList] = useState([]);
  const [selectedMovie, onMovieSelect] = useState();
  const [timeoutId, updateTimeoutId] = useState();

useEffect(() => {
  const savedSearchQuery = localStorage.getItem('searchQuery');
  const savedMovieListString = localStorage.getItem('movieList');
  if (savedSearchQuery && savedMovieListString) {
    updateSearchQuery(savedSearchQuery);
    updateMovieList(JSON.parse(savedMovieListString));
  }
}, []);


useEffect(() => {
    localStorage.setItem('searchQuery', searchQuery);
    localStorage.setItem('movieList', JSON.stringify(movieList));
  }, [searchQuery, movieList]);

const fetchData = async (searchString) => {
  const response = await Axios.get(
    `https://www.omdbapi.com/?s=${searchString}&apikey=${API_KEY}`,
  );
  if (response.data.Search) {
    updateMovieList(response.data.Search);
  }
};

localStorage.clear();

  const onTextChange = (e) => {
    onMovieSelect("");
    clearTimeout(timeoutId);
    updateSearchQuery(e.target.value);
    const timeout = setTimeout(() => fetchData(e.target.value), 500);
    updateTimeoutId(timeout);
  };

  return (
    <>
    <div className="search-container">
      <input
        className="search-input"
        placeholder="Search Movie or Series"
        value={searchQuery}
        onChange={onTextChange}
      />
    </div>
    {selectedMovie && <MovieInfoComponent selectedMovie={selectedMovie} onMovieSelect={onMovieSelect}/>}
    <div className ='MovieListContainer'>
    {movieList?.length ? (
          movieList.map((movie, index) => (
            <MovieComponent
            key={index}
            movie={movie}
            onMovieSelect={onMovieSelect}
            />
          ))
        ):<>
        <text><br/>You haven't made any searches yet.</text>
        </>
        }
    </div>
    </>
  );  
};

export default Search;
